export enum IFrameMessageTypes {
    REQUEST_AAD_TOKEN = "ProductCatalog_Request_AAD_Token",
    RESPONSE_AAD_TOKEN = "ProductCatalog_Response_AAD_Token",
    INIT_AUTH_CONTEXT = "ProductCatalog_INIT_AUTH_CONTEXT",
    REQUEST_CURRENT_USER = "ProductCatalog_REQUEST_CURRENT_USER",
    RESPONSE_CURRENT_USER = "ProductCatalog_RESPONSE_CURRENT_USER",
    TRY_HANDLE_WINDOW_CALLBACK = "ProductCatalog_TRY_HANDLE_WINDOW_CALLBACK",
    IS_TOKEN_RENEWAL_IN_PROGRESS = "ProductCatalog_IS_TOKEN_RENEWAL_IN_PROGRESS"
}
